import React from "react";
import {Button, Modal} from "semantic-ui-react";
import Table from "../../../../common/components/Table/Table";
import MARVEL from "../../../../common/utils/MarvelUrls";
import {connect} from "react-redux";
import {generateAllTenantsReport} from "../../../../report-generation/veritas-report-gen/ReportGeneratorActions";
import _ from "lodash";
import COUNTRIES from "../../../../common/resources/countries.json";
import lodash from "lodash/core";

// Currently, everything under this component is in this file. We can
// go ahead and split that as the use cases arise.
export class AdditionalDetails extends React.Component {

   state = {
       modalOpen: false,
       selectedCountry: null,
       collapseConfigNames: false,
   }

    componentWillUnmount() {
        this.setState({
            modalOpen: false,
            selectedCountry: null,
        });
    }

    handleTenantsModalReportClick = () => {
        const {serviceDetail}=this.props;
        const {selectedCountry}=this.state;
        this.props.generateAllTenantsXLXSReport(serviceDetail.service_detail.service_id, selectedCountry, serviceDetail.service_detail.dp_type)
    }

    handleViewOneCountryTenant = (e) => {
        const selectedCountryISO = e.currentTarget.dataset.id;
        this.setState({
            modalOpen: true,
            selectedCountry: selectedCountryISO,
        });
    }

    get infoSection() {
        const {serviceDetail, all_service_sets} = this.props;
        let configNames = serviceDetail.service_config_names;

        return (
            <div>
                <div>
                    <span>
                        <Button
                            color={serviceDetail.service_detail.integration_status === false
                                ? "red"
                                : "green"}
                            content={serviceDetail.service_detail.integration_status === false
                                ? `Not Integrated`
                                : `Integrated`}
                            size="small"
                        />
                    </span>
                    <span className="additional-detail-subheader">
                        <h3>Data Provider</h3>
                        <i><strong>{serviceDetail.associated_dp.provider_name}</strong></i>
                    </span>
                </div>

                <div className={"service-config-names-table"}>
                    <h3>Service Config Names</h3>
                    <Table style={{width: "75px"}}>
                        {configNames
                            ? configNames.map((svcConfig, idx) => {

                                if(svcConfig.is_primary) {
                                    return (
                                        <tr key={idx}>
                                            <td>
                                                <b>
                                                    {svcConfig.name} ({lodash.find(all_service_sets, {
                                                    collectionid: svcConfig.collectionid}).name}) <br/>
                                                </b>
                                            </td>
                                        </tr>
                                    )
                                } else {
                                    return (
                                        <tr key={idx}>
                                            <td>
                                                {svcConfig.name} ({lodash.find(all_service_sets, {
                                                collectionid: svcConfig.collectionid}).name})
                                            </td>
                                        </tr>
                                    )
                                }

                            })
                            : null
                        }
                    </Table>
                </div>
            </div>
        );

    }

    get tenantsTable() {
        const {associatedTenants} = this.props;

        if (_.isEmpty(associatedTenants)) {
            return (
                <div>
                    <h3>No Associated Tenants</h3>
                </div>
            );
        } else {
            return (
                <div>
                    <h3>Tenants Usage</h3>
                    <Table style={{width: "75px"}}>
                        {associatedTenants === null
                            ? null
                            : (Object.entries(associatedTenants).map(([key, value]) => {
                                    const countryName = _.result(_.find(COUNTRIES, {"value": key}), "label");

                                    return (
                                        <tr key={key}>
                                            <td>
                                                {countryName} {"("}{value.length}{")"}
                                            </td>
                                            <td>
                                                <u style={{cursor: "pointer"}}
                                                   onClick={this.handleViewOneCountryTenant.bind(this)}
                                                   data-id={key}
                                                >View
                                                </u>
                                            </td>
                                        </tr>
                                    )
                                }
                            ))
                        }
                    </Table>

                    <span className="view-all-tenants-button">
                        <Button
                            content={"View All Tenants"}
                            onClick={this.handleViewOneCountryTenant.bind(this)}
                            data-id={"ALL"}
                        />
                    </span>
                </div>
            );
        }
    }

    get modalTableHeaders() {
        return [
            <Table.Header key="tenant">Tenant Name</Table.Header>,
            <Table.Header key="country">Country</Table.Header>,
            <Table.Header key="service-group">Service Group</Table.Header>
        ];
    }

    get modalTenantsTable() {
        const {associatedTenants, associatedCountries} = this.props;
        const {selectedCountry} = this.state;
        // since the associatedTenants is a nested object, we flatten it here and add the country-iso
        // to the individual tenants array for the purposes of rendering and push all the associated tenants
        // under one big array of arrays.
        const showAllTenantsObject = { ALL: [] }
        if (selectedCountry === "ALL") {
            associatedCountries.forEach(country => {
                associatedTenants[country].forEach(tenantName => {
                    tenantName.push(country)
                    showAllTenantsObject["ALL"].push(tenantName)
                })
            })
        }

        return (
            <div className="all-tenants-modal">
                { this.props.isDPEditor ? (
                    <div className="tenants-list-xlsx-button">
                        <Button
                            icon="file excel outline" size="big"
                            onClick={this.handleTenantsModalReportClick}
                        />
                    </div>
                ) : null }
                <div className="sticky-table-container modal-tenants-table">
                    <Table
                        headers={this.modalTableHeaders}
                        className="sticky-table modal-tenants-table"
                    >
                        {selectedCountry === "ALL"
                            ? (showAllTenantsObject["ALL"].map((tenantName, idx) => {
                                return (
                                    <tr key={idx}>
                                        <td>
                                            <a
                                                target="_blank" rel="noopener noreferrer"
                                                href={MARVEL.CONFIG_TOOL.routeToTenantDetail + tenantName[1]}>
                                                {tenantName[0]}</a>
                                        </td>
                                        <td>
                                            <span>{tenantName[3]}</span>
                                        </td>
                                        <td>
                                            <span>{tenantName[2]}</span>
                                        </td>
                                    </tr>
                                )
                            }))
                            : null
                        }

                        {selectedCountry in associatedTenants
                            ? (associatedTenants[selectedCountry].map((tenantName, idx) => {
                                    return (
                                        <tr key={idx}>
                                            <td>
                                                <a
                                                    target="_blank" rel="noopener noreferrer"
                                                    href={MARVEL.CONFIG_TOOL.routeToTenantDetail + tenantName[1]}>
                                                    {tenantName[0]}</a>
                                            </td>
                                            <td>
                                                <span>{selectedCountry}</span>
                                            </td>
                                            <td>
                                                <span>{tenantName[2]}</span>
                                            </td>
                                        </tr>
                                    )}
                                )
                            )
                            : null
                        }
                    </Table>
                </div>
            </div>
        )
    }

    render() {
        const {serviceDetail} = this.props;

        return(
            <div className={"additional-details-container"}>
                {this.infoSection}
                {this.tenantsTable}

                <Modal
                    centered={false}
                    dimmer="blurring"
                    open={this.state.modalOpen}
                >
                    <Modal.Header>
                        {"Tenants Associated with " + serviceDetail.service_detail.service_name}
                    </Modal.Header>
                    <Modal.Content scrolling>
                        {this.modalTenantsTable}
                    </Modal.Content>
                    <Modal.Actions>
                        <Button
                            type="button"
                            color="red"
                            inverted
                            onClick={() => this.setState({modalOpen: false})}
                        >Close
                        </Button>
                    </Modal.Actions>
                </Modal>

            </div>
        )
    }
}

const mapStateToProps = (state) => ({
    associatedTenants: state.veritas.serviceDetail.associatedTenants,
    associatedCountries: state.veritas.serviceDetail.associatedCountries,
    serviceDetail: state.veritas.serviceDetail.service,
    all_service_sets: state.veritas.services.all_service_sets,
    isDPEditor: state.marvel.user.access.accessLevel.isDPEditor,
});

const mapDispatchToProps = dispatch => ({
    generateAllTenantsXLXSReport: (serviceID, selectedCountry, serviceType) =>
    {dispatch(generateAllTenantsReport(serviceID, selectedCountry, serviceType))},
})

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(AdditionalDetails)
